import LocalizedStrings from "react-localization";
import {resource_strings} from "../translations/resource_translations";
import localeHelpers from "./LocaleHelper";
import constants from "../shared/constants";
import React from "react";
import {common_strings} from "../translations/common_translations";
const resourceStrings = new LocalizedStrings(resource_strings);
const commonStrings = new LocalizedStrings(common_strings);

const cabinetSections = {

    sections: function () {
        resourceStrings.setLanguage(localeHelpers.currentLocale());
        commonStrings.setLanguage(localeHelpers.currentLocale());

        return [
            {
                type: constants.cabinet.team_management,
                title: resourceStrings.cabinet.team_management,
                icon: <i className="fas fa-users-cog"/>,
                iconColor: "bg-success",
                description: resourceStrings.cabinet.team_management_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.messaging,
                title: resourceStrings.cabinet.messaging,
                icon: <i className="fas fa-envelope"/>,
                iconColor: "bg-purple",
                description: resourceStrings.cabinet.messaging_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.invoices,
                title: resourceStrings.cabinet.invoices,
                icon: <i className="fas fa-file-invoice"/>,
                iconColor: "bg-info",
                description: resourceStrings.cabinet.invoices_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.incomes_expenses,
                title: resourceStrings.cabinet.incomes_and_expenses,
                icon: <i className="fas fa-coins"/>,
                iconColor: "bg-yellow",
                description: resourceStrings.cabinet.incomes_and_expenses_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.cashier,
                title: resourceStrings.cabinet.cashier,
                icon: <i className="fas fa-cash-register"/>,
                iconColor: "bg-orange",
                description: resourceStrings.cabinet.cashier_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.feedbacks,
                title: commonStrings.feedback,
                icon: <img width={20}
                           height={20}
                           alt="pm" src={require("assets/img/icons/common/good-feedback.svg").default}/>,
                iconColor: "bg-purple",
                description: commonStrings.feedback_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.teacher_sessions,
                title: commonStrings.teacher_sessions,
                icon: <img width={20}
                           height={20}
                           alt="ts" src={require("assets/img/icons/common/working-hours.svg").default}/>,
                iconColor: "bg-green",
                description: commonStrings.teacher_sessions_expl,
                nikitaOnly: false,
            },
            {
                type: constants.cabinet.user_data,
                title: "-USER DATA-",
                icon: <i className="fas fa-database"/>,
                iconColor: "bg-yellow",
                description: "Users with new classes, students or events in the past 7 days",
                nikitaOnly: true,
            },
            {
                type: constants.cabinet.new_users,
                title: "-TRENDS-",
                icon: <i className="fas fa-database"/>,
                iconColor: "bg-pink",
                description: "",
                nikitaOnly: true,
            },
            {
                type: constants.cabinet.ahoy_events,
                title: "-AHOY EVENTS-",
                icon: <i className="fas fa-search"/>,
                iconColor: "bg-purple",
                description: "",
                nikitaOnly: true,
            },
            {
                type: constants.cabinet.new_clients,
                title: "-NEW CLIENTS-",
                icon: <i className="fas fa-user-astronaut"/>,
                iconColor: "bg-gradient-blue",
                description: "",
                nikitaOnly: true,
            },
            {
                type: constants.cabinet.subscriptions,
                title: "-SUBSCRIPTIONS-",
                icon: <i className="fas fa-money-bill"/>,
                iconColor: "bg-gradient-red",
                description: "",
                nikitaOnly: true,
            },
        ];
    },
};

export default cabinetSections;